import ReactGA from 'react-ga';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { Footer, Header } from './components';
import NewHomePage from './pages/newHomePage';
import ContactPage from './pages/contactPage';
import { useEffect } from 'react';
import FunctionPages from './pages/functionsPage';


const TRACKING_ID = "UA-133866763-2";

ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname);

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
	return (
		<Router>
			<ScrollToTop />
			<Header />
			<Routes>
				<Route path="/" element={<NewHomePage />} exact />
        <Route path='/feature/:name' element={<FunctionPages/>} />
				<Route path="/contact" element={<ContactPage />} />
			</Routes>
			<Footer />
		</Router>
	);
}

export default App;
